import type { CountryInfo } from '../types/country-info';

export const DEFAULT_COUNTRY_INFO: CountryInfo = {
  code: 'US',
  name: 'United States',
  flagEmoji: '🇺🇸',
};

export const COUNTRY_INFO_MAP: Record<string, CountryInfo> = {
  AF: { code: 'AF', name: 'Afghanistan', flagEmoji: '🇦🇫' },
  AL: { code: 'AL', name: 'Albania', flagEmoji: '🇦🇱' },
  DZ: { code: 'DZ', name: 'Algeria', flagEmoji: '🇩🇿' },
  AD: { code: 'AD', name: 'Andorra', flagEmoji: '🇦🇩' },
  AO: { code: 'AO', name: 'Angola', flagEmoji: '🇦🇴' },
  AG: { code: 'AG', name: 'Antigua and Barbuda', flagEmoji: '🇦🇬' },
  AR: { code: 'AR', name: 'Argentina', flagEmoji: '🇦🇷' },
  AM: { code: 'AM', name: 'Armenia', flagEmoji: '🇦🇲' },
  AU: { code: 'AU', name: 'Australia', flagEmoji: '🇦🇺' },
  AT: { code: 'AT', name: 'Austria', flagEmoji: '🇦🇹' },
  AZ: { code: 'AZ', name: 'Azerbaijan', flagEmoji: '🇦🇿' },
  BS: { code: 'BS', name: 'Bahamas', flagEmoji: '🇧🇸' },
  BH: { code: 'BH', name: 'Bahrain', flagEmoji: '🇧🇭' },
  BD: { code: 'BD', name: 'Bangladesh', flagEmoji: '🇧🇩' },
  BB: { code: 'BB', name: 'Barbados', flagEmoji: '🇧🇧' },
  BY: { code: 'BY', name: 'Belarus', flagEmoji: '🇧🇾' },
  BE: { code: 'BE', name: 'Belgium', flagEmoji: '🇧🇪' },
  BZ: { code: 'BZ', name: 'Belize', flagEmoji: '🇧🇿' },
  BJ: { code: 'BJ', name: 'Benin', flagEmoji: '🇧🇯' },
  BT: { code: 'BT', name: 'Bhutan', flagEmoji: '🇧🇹' },
  BO: { code: 'BO', name: 'Bolivia', flagEmoji: '🇧🇴' },
  BA: { code: 'BA', name: 'Bosnia and Herzegovina', flagEmoji: '🇧🇦' },
  BW: { code: 'BW', name: 'Botswana', flagEmoji: '🇧🇼' },
  BR: { code: 'BR', name: 'Brazil', flagEmoji: '🇧🇷' },
  BN: { code: 'BN', name: 'Brunei', flagEmoji: '🇧🇳' },
  BG: { code: 'BG', name: 'Bulgaria', flagEmoji: '🇧🇬' },
  BF: { code: 'BF', name: 'Burkina Faso', flagEmoji: '🇧🇫' },
  BI: { code: 'BI', name: 'Burundi', flagEmoji: '🇧🇮' },
  CV: { code: 'CV', name: 'Cape Verde', flagEmoji: '🇨🇻' },
  KH: { code: 'KH', name: 'Cambodia', flagEmoji: '🇰🇭' },
  CM: { code: 'CM', name: 'Cameroon', flagEmoji: '🇨🇲' },
  CA: { code: 'CA', name: 'Canada', flagEmoji: '🇨🇦' },
  CF: { code: 'CF', name: 'Central African Republic', flagEmoji: '🇨🇫' },
  TD: { code: 'TD', name: 'Chad', flagEmoji: '🇹🇩' },
  CL: { code: 'CL', name: 'Chile', flagEmoji: '🇨🇱' },
  CN: { code: 'CN', name: 'China', flagEmoji: '🇨🇳' },
  CO: { code: 'CO', name: 'Colombia', flagEmoji: '🇨🇴' },
  KM: { code: 'KM', name: 'Comoros', flagEmoji: '🇰🇲' },
  CG: { code: 'CG', name: 'Congo', flagEmoji: '🇨🇬' },
  CD: { code: 'CD', name: 'Congo (DRC)', flagEmoji: '🇨🇩' },
  CR: { code: 'CR', name: 'Costa Rica', flagEmoji: '🇨🇷' },
  HR: { code: 'HR', name: 'Croatia', flagEmoji: '🇭🇷' },
  CU: { code: 'CU', name: 'Cuba', flagEmoji: '🇨🇺' },
  CY: { code: 'CY', name: 'Cyprus', flagEmoji: '🇨🇾' },
  CZ: { code: 'CZ', name: 'Czech Republic', flagEmoji: '🇨🇿' },
  DK: { code: 'DK', name: 'Denmark', flagEmoji: '🇩🇰' },
  DJ: { code: 'DJ', name: 'Djibouti', flagEmoji: '🇩🇯' },
  DM: { code: 'DM', name: 'Dominica', flagEmoji: '🇩🇲' },
  DO: { code: 'DO', name: 'Dominican Republic', flagEmoji: '🇩🇴' },
  EC: { code: 'EC', name: 'Ecuador', flagEmoji: '🇪🇨' },
  EG: { code: 'EG', name: 'Egypt', flagEmoji: '🇪🇬' },
  SV: { code: 'SV', name: 'El Salvador', flagEmoji: '🇸🇻' },
  GQ: { code: 'GQ', name: 'Equatorial Guinea', flagEmoji: '🇬🇶' },
  ER: { code: 'ER', name: 'Eritrea', flagEmoji: '🇪🇷' },
  EE: { code: 'EE', name: 'Estonia', flagEmoji: '🇪🇪' },
  SZ: { code: 'SZ', name: 'Eswatini', flagEmoji: '🇸🇿' },
  ET: { code: 'ET', name: 'Ethiopia', flagEmoji: '🇪🇹' },
  FJ: { code: 'FJ', name: 'Fiji', flagEmoji: '🇫🇯' },
  FI: { code: 'FI', name: 'Finland', flagEmoji: '🇫🇮' },
  FR: { code: 'FR', name: 'France', flagEmoji: '🇫🇷' },
  GA: { code: 'GA', name: 'Gabon', flagEmoji: '🇬🇦' },
  GM: { code: 'GM', name: 'Gambia', flagEmoji: '🇬🇲' },
  GE: { code: 'GE', name: 'Georgia', flagEmoji: '🇬🇪' },
  DE: { code: 'DE', name: 'Germany', flagEmoji: '🇩🇪' },
  GH: { code: 'GH', name: 'Ghana', flagEmoji: '🇬🇭' },
  GR: { code: 'GR', name: 'Greece', flagEmoji: '🇬🇷' },
  GD: { code: 'GD', name: 'Grenada', flagEmoji: '🇬🇩' },
  GT: { code: 'GT', name: 'Guatemala', flagEmoji: '🇬🇹' },
  GN: { code: 'GN', name: 'Guinea', flagEmoji: '🇬🇳' },
  GW: { code: 'GW', name: 'Guinea-Bissau', flagEmoji: '🇬🇼' },
  GY: { code: 'GY', name: 'Guyana', flagEmoji: '🇬🇾' },
  HT: { code: 'HT', name: 'Haiti', flagEmoji: '🇭🇹' },
  HN: { code: 'HN', name: 'Honduras', flagEmoji: '🇭🇳' },
  HK: { code: 'HK', name: 'Hong Kong', flagEmoji: '🇭🇰' },
  HU: { code: 'HU', name: 'Hungary', flagEmoji: '🇭🇺' },
  IS: { code: 'IS', name: 'Iceland', flagEmoji: '🇮🇸' },
  IN: { code: 'IN', name: 'India', flagEmoji: '🇮🇳' },
  ID: { code: 'ID', name: 'Indonesia', flagEmoji: '🇮🇩' },
  IR: { code: 'IR', name: 'Iran', flagEmoji: '🇮🇷' },
  IQ: { code: 'IQ', name: 'Iraq', flagEmoji: '🇮🇶' },
  IE: { code: 'IE', name: 'Ireland', flagEmoji: '🇮🇪' },
  IL: { code: 'IL', name: 'Israel', flagEmoji: '🇮🇱' },
  IT: { code: 'IT', name: 'Italy', flagEmoji: '🇮🇹' },
  CI: { code: 'CI', name: 'Ivory Coast', flagEmoji: '🇨🇮' },
  JM: { code: 'JM', name: 'Jamaica', flagEmoji: '🇯🇲' },
  JP: { code: 'JP', name: 'Japan', flagEmoji: '🇯🇵' },
  JO: { code: 'JO', name: 'Jordan', flagEmoji: '🇯🇴' },
  KZ: { code: 'KZ', name: 'Kazakhstan', flagEmoji: '🇰🇿' },
  KE: { code: 'KE', name: 'Kenya', flagEmoji: '🇰🇪' },
  KI: { code: 'KI', name: 'Kiribati', flagEmoji: '🇰🇮' },
  KW: { code: 'KW', name: 'Kuwait', flagEmoji: '🇰🇼' },
  KG: { code: 'KG', name: 'Kyrgyzstan', flagEmoji: '🇰🇬' },
  LA: { code: 'LA', name: 'Laos', flagEmoji: '🇱🇦' },
  LV: { code: 'LV', name: 'Latvia', flagEmoji: '🇱🇻' },
  LB: { code: 'LB', name: 'Lebanon', flagEmoji: '🇱🇧' },
  LS: { code: 'LS', name: 'Lesotho', flagEmoji: '🇱🇸' },
  LR: { code: 'LR', name: 'Liberia', flagEmoji: '🇱🇷' },
  LY: { code: 'LY', name: 'Libya', flagEmoji: '🇱🇾' },
  LI: { code: 'LI', name: 'Liechtenstein', flagEmoji: '🇱🇮' },
  LT: { code: 'LT', name: 'Lithuania', flagEmoji: '🇱🇹' },
  LU: { code: 'LU', name: 'Luxembourg', flagEmoji: '🇱🇺' },
  MO: { code: 'MO', name: 'Macau', flagEmoji: '🇲🇴' },
  MG: { code: 'MG', name: 'Madagascar', flagEmoji: '🇲🇬' },
  MW: { code: 'MW', name: 'Malawi', flagEmoji: '🇲🇼' },
  MY: { code: 'MY', name: 'Malaysia', flagEmoji: '🇲🇾' },
  MV: { code: 'MV', name: 'Maldives', flagEmoji: '🇲🇻' },
  ML: { code: 'ML', name: 'Mali', flagEmoji: '🇲🇱' },
  MT: { code: 'MT', name: 'Malta', flagEmoji: '🇲🇹' },
  MH: { code: 'MH', name: 'Marshall Islands', flagEmoji: '🇲🇭' },
  MR: { code: 'MR', name: 'Mauritania', flagEmoji: '🇲🇷' },
  MU: { code: 'MU', name: 'Mauritius', flagEmoji: '🇲🇺' },
  MX: { code: 'MX', name: 'Mexico', flagEmoji: '🇲🇽' },
  FM: { code: 'FM', name: 'Micronesia', flagEmoji: '🇫🇲' },
  MD: { code: 'MD', name: 'Moldova', flagEmoji: '🇲🇩' },
  MC: { code: 'MC', name: 'Monaco', flagEmoji: '🇲🇨' },
  MN: { code: 'MN', name: 'Mongolia', flagEmoji: '🇲🇳' },
  ME: { code: 'ME', name: 'Montenegro', flagEmoji: '🇲🇪' },
  MA: { code: 'MA', name: 'Morocco', flagEmoji: '🇲🇦' },
  MZ: { code: 'MZ', name: 'Mozambique', flagEmoji: '🇲🇿' },
  MM: { code: 'MM', name: 'Myanmar', flagEmoji: '🇲🇲' },
  NA: { code: 'NA', name: 'Namibia', flagEmoji: '🇳🇦' },
  NR: { code: 'NR', name: 'Nauru', flagEmoji: '🇳🇷' },
  NP: { code: 'NP', name: 'Nepal', flagEmoji: '🇳🇵' },
  NL: { code: 'NL', name: 'Netherlands', flagEmoji: '🇳🇱' },
  NZ: { code: 'NZ', name: 'New Zealand', flagEmoji: '🇳🇿' },
  NI: { code: 'NI', name: 'Nicaragua', flagEmoji: '🇳🇮' },
  NE: { code: 'NE', name: 'Niger', flagEmoji: '🇳🇪' },
  NG: { code: 'NG', name: 'Nigeria', flagEmoji: '🇳🇬' },
  MK: { code: 'MK', name: 'North Macedonia', flagEmoji: '🇲🇰' },
  NO: { code: 'NO', name: 'Norway', flagEmoji: '🇳🇴' },
  OM: { code: 'OM', name: 'Oman', flagEmoji: '🇴🇲' },
  PK: { code: 'PK', name: 'Pakistan', flagEmoji: '🇵🇰' },
  PW: { code: 'PW', name: 'Palau', flagEmoji: '🇵🇼' },
  PA: { code: 'PA', name: 'Panama', flagEmoji: '🇵🇦' },
  PG: { code: 'PG', name: 'Papua New Guinea', flagEmoji: '🇵🇬' },
  PY: { code: 'PY', name: 'Paraguay', flagEmoji: '🇵🇾' },
  PE: { code: 'PE', name: 'Peru', flagEmoji: '🇵🇪' },
  PH: { code: 'PH', name: 'Philippines', flagEmoji: '🇵🇭' },
  PL: { code: 'PL', name: 'Poland', flagEmoji: '🇵🇱' },
  PT: { code: 'PT', name: 'Portugal', flagEmoji: '🇵🇹' },
  QA: { code: 'QA', name: 'Qatar', flagEmoji: '🇶🇦' },
  RO: { code: 'RO', name: 'Romania', flagEmoji: '🇷🇴' },
  RU: { code: 'RU', name: 'Russia', flagEmoji: '🇷🇺' },
  RW: { code: 'RW', name: 'Rwanda', flagEmoji: '🇷🇼' },
  KN: { code: 'KN', name: 'Saint Kitts and Nevis', flagEmoji: '🇰🇳' },
  LC: { code: 'LC', name: 'Saint Lucia', flagEmoji: '🇱🇨' },
  VC: { code: 'VC', name: 'Saint Vincent and the Grenadines', flagEmoji: '🇻🇨' },
  WS: { code: 'WS', name: 'Samoa', flagEmoji: '🇼🇸' },
  SM: { code: 'SM', name: 'San Marino', flagEmoji: '🇸🇲' },
  ST: { code: 'ST', name: 'São Tomé and Príncipe', flagEmoji: '🇸🇹' },
  SA: { code: 'SA', name: 'Saudi Arabia', flagEmoji: '🇸🇦' },
  SN: { code: 'SN', name: 'Senegal', flagEmoji: '🇸🇳' },
  RS: { code: 'RS', name: 'Serbia', flagEmoji: '🇷🇸' },
  SC: { code: 'SC', name: 'Seychelles', flagEmoji: '🇸🇨' },
  SL: { code: 'SL', name: 'Sierra Leone', flagEmoji: '🇸🇱' },
  SG: { code: 'SG', name: 'Singapore', flagEmoji: '🇸🇬' },
  SK: { code: 'SK', name: 'Slovakia', flagEmoji: '🇸🇰' },
  SI: { code: 'SI', name: 'Slovenia', flagEmoji: '🇸🇮' },
  SB: { code: 'SB', name: 'Solomon Islands', flagEmoji: '🇸🇧' },
  SO: { code: 'SO', name: 'Somalia', flagEmoji: '🇸🇴' },
  ZA: { code: 'ZA', name: 'South Africa', flagEmoji: '🇿🇦' },
  SS: { code: 'SS', name: 'South Sudan', flagEmoji: '🇸🇸' },
  KR: { code: 'KR', name: 'South Korea', flagEmoji: '🇰🇷' },
  ES: { code: 'ES', name: 'Spain', flagEmoji: '🇪🇸' },
  LK: { code: 'LK', name: 'Sri Lanka', flagEmoji: '🇱🇰' },
  SD: { code: 'SD', name: 'Sudan', flagEmoji: '🇸🇩' },
  SR: { code: 'SR', name: 'Suriname', flagEmoji: '🇸🇷' },
  SE: { code: 'SE', name: 'Sweden', flagEmoji: '🇸🇪' },
  CH: { code: 'CH', name: 'Switzerland', flagEmoji: '🇨🇭' },
  SY: { code: 'SY', name: 'Syria', flagEmoji: '🇸🇾' },
  TW: { code: 'TW', name: 'Taiwan', flagEmoji: '🇹🇼' },
  TJ: { code: 'TJ', name: 'Tajikistan', flagEmoji: '🇹🇯' },
  TZ: { code: 'TZ', name: 'Tanzania', flagEmoji: '🇹🇿' },
  TH: { code: 'TH', name: 'Thailand', flagEmoji: '🇹🇭' },
  TL: { code: 'TL', name: 'Timor-Leste', flagEmoji: '🇹🇱' },
  TG: { code: 'TG', name: 'Togo', flagEmoji: '🇹🇬' },
  TO: { code: 'TO', name: 'Tonga', flagEmoji: '🇹🇴' },
  TT: { code: 'TT', name: 'Trinidad and Tobago', flagEmoji: '🇹🇹' },
  TN: { code: 'TN', name: 'Tunisia', flagEmoji: '🇹🇳' },
  TR: { code: 'TR', name: 'Turkey', flagEmoji: '🇹🇷' },
  TM: { code: 'TM', name: 'Turkmenistan', flagEmoji: '🇹🇲' },
  TV: { code: 'TV', name: 'Tuvalu', flagEmoji: '🇹🇻' },
  UG: { code: 'UG', name: 'Uganda', flagEmoji: '🇺🇬' },
  UA: { code: 'UA', name: 'Ukraine', flagEmoji: '🇺🇦' },
  AE: { code: 'AE', name: 'United Arab Emirates', flagEmoji: '🇦🇪' },
  GB: { code: 'GB', name: 'United Kingdom', flagEmoji: '🇬🇧' },
  US: DEFAULT_COUNTRY_INFO,
  UY: { code: 'UY', name: 'Uruguay', flagEmoji: '🇺🇾' },
  UZ: { code: 'UZ', name: 'Uzbekistan', flagEmoji: '🇺🇿' },
  VU: { code: 'VU', name: 'Vanuatu', flagEmoji: '🇻🇺' },
  VE: { code: 'VE', name: 'Venezuela', flagEmoji: '🇻🇪' },
  VN: { code: 'VN', name: 'Vietnam', flagEmoji: '🇻🇳' },
  YE: { code: 'YE', name: 'Yemen', flagEmoji: '🇾🇪' },
  ZM: { code: 'ZM', name: 'Zambia', flagEmoji: '🇿🇲' },
  ZW: { code: 'ZW', name: 'Zimbabwe', flagEmoji: '🇿🇼' },
};
